import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { IFieldConfig } from "../../../../domain/IFieldConfig";
import { IColumnConfigTableResponsive } from "../../../../domain/IColumnConfigTableResponsive";
import { MatTableDataSource } from "@angular/material/table";
import { MatSidenav } from '@angular/material/sidenav';
import { Router, NavigationEnd, Event } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AuthService } from 'src/app/views/auth/shared/auth.service';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';

@Component({
  selector: 'app-layout-crud-index',
  templateUrl: './layout-crud-index.component.html',
  styleUrls: ['./layout-crud-index.component.sass'],
  providers: [
    {
      provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
      useValue: { showDelay: 450, hideDelay: 0, touchendHideDelay: 0 }
    }
  ]
})
export class LayoutCrudIndexComponent implements OnInit {

  @Input() titulo: string;
  @Input() filterFields: IFieldConfig[];
  @Input() length: number;
  @Input() configColumns: IColumnConfigTableResponsive[];
  @Input() displayedColumns: string[];
  @Input() dataSource: MatTableDataSource<any>;
  @Input() filterInitialValues: any = null; // Valores iniciais para o filtro
  @Input() customClass: string | string[] = '';
  @Input() mode: 'list' | 'edit' = 'list'; // Novo input para controlar o modo
  @Input() visibleIcons: string[] | null = null; // Visible icons: 'settings' | 'filters' | 'partners' | 'global' | 'financial' | 'charges' | 'home'

  @Output() onChangePage: EventEmitter<any> = new EventEmitter<any>();
  @Output() onFilter: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSubmitAdvancedFilter: EventEmitter<any> = new EventEmitter<any>();
  @Output() onResetFilter: EventEmitter<any> = new EventEmitter<any>();

  @Output() onOpenShow: EventEmitter<any> = new EventEmitter<any>();
  @Output() onOpenNew: EventEmitter<any> = new EventEmitter<any>();
  @Output() onOpenEdit: EventEmitter<any> = new EventEmitter<any>();
  @Output() onOpenDelete: EventEmitter<any> = new EventEmitter<any>();
  @Output() settings: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('sidenav') sidenav: MatSidenav;

  // Propriedade para armazenar a rota atual
  currentRoute: string = '';

  isMerchant: boolean = false;

  constructor(
    private router: Router,
    private authService: AuthService
  ) {
    // Monitorar alterações na rota para atualizar a propriedade currentRoute
    this.router.events.pipe(
      filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.currentRoute = event.url;
    });
  }

  ngOnInit(): void {
    // Inicializar currentRoute com a rota atual
    this.currentRoute = this.router.url;

    this.isMerchant = this.authService.isMerchant();
  }

  shouldShowIcon(icon: string): boolean {
    return !this.visibleIcons || this.visibleIcons.includes(icon);
  }

  // Verificar se a rota atual é uma das desejadas
  // isOnCommissionDashboardOrDashboard(): boolean {
  //   return this.currentRoute === '/partner-dashboard' ||
  //          this.currentRoute === '/dashboard' ||
  //          this.currentRoute === '/accounts-dashboard';
  // }

  // Verificar se o botão específico está ativo
  isActiveRoute(route: string): boolean {
    return this.currentRoute === route;
  }

  // Verificar se o usuário não é parceiro para exibir o botão do dashboard financeiro
  canShowFinancialDashboard(): boolean {
    return true;
  }

  canShowDashboard(): boolean {
    return !this.authService.isPartner();
  }

  get isFinancial(): boolean {
    return this.authService.isFinancial();
  }

  // Navegar para o dashboard de comissões
  navigateToCommissionDashboard(): void {
    this.router.navigate(['/partner-dashboard']);
  }

  // Navegar para o dashboard principal
  navigateToDashboard(): void {
    this.router.navigate(['/dashboard']);
  }

  // Navegar para o dashboard de contas a receber
  navigateToAccountsDashboard(): void {
    this.router.navigate(['/accounts-dashboard']);
  }

  // Navegar para a tela de cobranças
  navigateToCharges(): void {
    this.router.navigate(['/my-account']);
  }

  // Navegar para a tela de home/cards
  navigateToHome(): void {
    if(this.isMerchant){
       this.router.navigate(['/my-account']);
       return;
    }
    this.router.navigate(['/home-cards']);
  }

  changePage($event: any) {
    this.onChangePage.emit($event);
  }

  filter($event: any) {
    this.onFilter.emit($event);
  }

  openSettings($event: any): void {
    this.settings.emit($event);
  }

  submitAdvancedFilter($event: any) {
    this.onSubmitAdvancedFilter.emit($event);
    this.sidenav.close();
  }

  resetFilter(): void {
    this.onResetFilter.emit();
    this.sidenav.close();
  }

  openShow($event: any) {
    this.onOpenShow.emit($event);
  }

  openNew($event: any) {
    this.onOpenNew.emit($event);
  }

  openEdit($event: any) {
    this.onOpenEdit.emit($event);
  }

  openDelete($event: any) {
    this.onOpenDelete.emit($event);
  }

}
